import React, { Component } from "react";
import BackButton from "./BackButton";
import FlexGrowSpace from "../../widgets/FlexGrowSpace";
import EatWithMeText from "../EatWIthMeText";
import RestaurantSelector from "../RestaurantSelector";
import ChatModal from "../../admin/ChatModal";
import ChatGptButton from "../icon-buttons/ChatGptButton";
import { decreaseZoom, getGlobalZoom, increaseZoom } from "../../js/auth";

class SubmenuHeader extends Component {
  state = {};

  constructor(props) {
    super(props);
    this.chatModalRef = React.createRef();
  }

  render() {
    const showMenuAutomationWizardButton = !!this.props.showMenuAutomationWizardButton;
    const wizardButtonTitle = "Automation wizard";

    return (
      <div className="menuItemHeader" >
        <EatWithMeText />
        <BackButton {...this.props} />
        <FlexGrowSpace />
        <RestaurantSelector myStatus={this.props.myStatus} onReload={this.props.onReload} disableDropdown />
        <FlexGrowSpace />
        <div id="zoom" style={{ display: "flex", alignItems: "center", color: "rgb(131, 123, 108)" }}>
          <div onClick={decreaseZoom} className="zoom icon-zoom-out-outline" />
          <h1 style={{ fontSize: "20px" }} id="zoomlevel2">{Math.round(getGlobalZoom() * 100) + "%"}</h1>
          <div onClick={increaseZoom} className="zoom icon-zoom-in-outline" />
        </div>
        <FlexGrowSpace />
        <h3 className="myTitle">{this.props.header}</h3>
        <ChatGptButton />
        <ChatModal ref={this.chatModalRef} {...this.props} />
        {showMenuAutomationWizardButton ? (
          <button
            type="button"
            className="p-button"
            style={{
              marginRight: 8,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 36,
              height: 36,
              padding: 0,
              background: "transparent",
              boxShadow: "none",
              border: "none",
              color: "inherit"
            }}
            onClick={this.props.onOpenMenuAutomationWizard}
            title={wizardButtonTitle}
            aria-label={wizardButtonTitle}
          >
            <svg
              aria-hidden="true"
              version="1.0"
              viewBox="0 0 512.000000 512.000000"
              width="22"
              height="22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="xMidYMid meet"
              style={{ display: "inline-block", verticalAlign: "middle" }}
            >
              <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#808080" stroke="#808080" strokeWidth="70" strokeLinejoin="round" strokeLinecap="round">
                <path d="M3620 5021 c-53 -97 -55 -100 -125 -137 -38 -21 -83 -45 -98 -55 l-29 -17 99 -53 100 -52 52 -100 53 -99 23 41 c13 22 38 67 55 99 28 53 38 63 108 100 131 70 129 61 18 122 l-96 54 -53 98 -53 99 -54 -100z" />
                <path d="M1529 4563 l-64 -117 -119 -65 c-137 -74 -139 -61 20 -146 l100 -54 63 -116 c34 -63 66 -115 71 -115 5 0 37 52 71 115 l63 116 100 54 c159 85 157 72 20 146 l-119 65 -64 117 c-36 64 -67 117 -71 117 -4 0 -35 -53 -71 -117z" />
                <path d="M2840 4457 c-30 -16 -52 -37 -68 -68 l-24 -44 7 -340 7 -340 -234 -165 c-128 -90 -256 -181 -285 -203 -77 -57 -103 -138 -67 -213 27 -57 66 -80 206 -124 73 -23 177 -55 231 -72 l99 -31 -1290 -1291 c-710 -710 -1297 -1305 -1306 -1323 -20 -40 -21 -115 -1 -153 21 -41 78 -81 123 -87 90 -12 25 -73 1414 1315 714 713 1299 1294 1301 1292 3 -3 33 -97 67 -210 35 -113 71 -221 81 -242 45 -90 156 -120 241 -64 14 9 113 140 219 291 l194 274 347 1 c191 0 358 4 371 9 72 28 118 128 93 202 -7 21 -102 158 -212 305 l-198 267 107 316 c67 198 107 331 107 356 0 71 -53 135 -125 154 -52 13 -58 12 -409 -108 l-299 -101 -266 199 c-146 110 -279 204 -294 210 -44 17 -90 13 -137 -12z m422 -608 c88 -66 172 -125 185 -130 48 -18 102 -8 293 56 107 36 195 65 195 65 1 0 -29 -91 -67 -202 -37 -112 -68 -213 -68 -226 0 -42 28 -90 142 -244 63 -84 117 -157 120 -163 4 -7 -66 -9 -205 -7 -280 4 -262 13 -417 -205 -63 -89 -120 -167 -125 -172 -7 -7 -30 54 -70 181 -60 193 -80 237 -125 269 -14 10 -110 45 -215 77 -104 33 -190 63 -190 67 0 4 74 59 165 124 92 65 174 131 187 150 22 33 23 41 23 257 0 123 2 224 5 224 3 0 78 -54 167 -121z" />
                <path d="M4809 3753 c-27 -49 -43 -65 -86 -88 -29 -15 -53 -31 -53 -35 0 -4 24 -20 53 -35 43 -23 59 -39 86 -88 l34 -61 29 58 c27 54 38 64 120 109 l32 19 -59 31 c-49 27 -64 42 -91 91 l-32 58 -33 -59z" />
                <path d="M4395 2167 c2 -7 20 -66 39 -133 l36 -121 -38 -132 c-22 -72 -35 -131 -29 -131 5 0 65 16 132 36 l123 36 127 -37 c70 -20 129 -34 132 -32 2 3 -12 62 -32 132 l-37 127 36 123 c20 67 36 127 36 133 0 5 -59 -8 -131 -29 l-131 -39 -121 36 c-67 19 -127 37 -134 39 -7 2 -10 -1 -8 -8z" />
                <path d="M3485 1404 c-72 -132 -71 -130 -172 -184 l-95 -52 28 -17 c16 -10 61 -34 99 -55 69 -37 71 -40 120 -132 28 -52 53 -94 56 -94 3 0 28 42 56 93 l50 92 97 55 c111 63 112 54 -17 123 l-78 42 -53 98 -54 99 -37 -68z" />
              </g>
            </svg>
          </button>
        ) : null}
      </div>
    );
  }
}

export default SubmenuHeader;
